import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Recent from "./recent_gallary/Recent";
import "./TabSection.css";
import { GalleryCategorys } from "../../../utils/apis/gallery/Gallery";
export default function TabSection() {
  const [key, setKey] = useState("recent");
  const [category, setGalleryCategory] = useState([]);

  const getGalleryCategorys = async () => {
    const res = await GalleryCategorys();
    if (res?.success) {
      setGalleryCategory(res.data);
    }
  };

  useEffect(() => {
    getGalleryCategorys();
  }, []);

  return (
    <div className="gallery-tabs-wrapper container">
      <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="custom-tabs">
        <Tab eventKey="recent" title="All Photos">
          <Recent  categoryId={''} />
        </Tab>

        {category.map((item) => (
          <Tab eventKey={item?.id} title={item?.name} key={item?.id}>
            <Recent categoryId={item?.id} />
          </Tab>
        ))}
      </Tabs>
    </div>
  );
}
